import facebook_icon from '../../core/assets/thirdPartyImages/ic_facebook.png';
import linkedin_icon from '../../core/assets/thirdPartyImages/ic_linkedin.png';
import twitter_icon from '../../core/assets/thirdPartyImages/ic_twitter.png';
import instagram_icon from '../../core/assets/thirdPartyImages/ic_instagram_big.png';
import venmo_icon from '../../core/assets/thirdPartyImages/ic_venmo.png';
import url_icon from '../../core/assets/thirdPartyImages/ic_url_big.png';
import messenger_icon from '../../core/assets/thirdPartyImages/ic_messenger_big.png';
import whatsapp_icon from '../../core/assets/thirdPartyImages/ic_whatsapp_big.png';
import yelp_icon from '../../core/assets/thirdPartyImages/ic_yelp.png';
import snapchat_icon from '../../core/assets/thirdPartyImages/ic_snapchat.png';

import { TAppContact, TAppThirdPartyIdSource } from 'TProtocol/common/models';

const ThirdPartyIcon : {
  [key in TAppThirdPartyIdSource]: string
} = {
  [TAppThirdPartyIdSource.UNDEFINED]: url_icon,
  [TAppThirdPartyIdSource.FACEBOOK]: facebook_icon,
  [TAppThirdPartyIdSource.LINKEDIN]: linkedin_icon,
  [TAppThirdPartyIdSource.TWITTER]: twitter_icon,
  [TAppThirdPartyIdSource.INSTAGRAM]: instagram_icon,
  [TAppThirdPartyIdSource.VENMO]: venmo_icon,
  [TAppThirdPartyIdSource.FACEBOOK_MESSENGER]: messenger_icon,
  [TAppThirdPartyIdSource.WHATSAPP]: whatsapp_icon,
  [TAppThirdPartyIdSource.YELP]: yelp_icon,
  [TAppThirdPartyIdSource.SNAPCHAT]: snapchat_icon,
  [TAppThirdPartyIdSource.URL]: url_icon,
}

const ThirdPartyName: {
  [key in TAppThirdPartyIdSource]: string
} = {
  [TAppThirdPartyIdSource.UNDEFINED]: '',
  [TAppThirdPartyIdSource.FACEBOOK]: 'Facebook',
  [TAppThirdPartyIdSource.LINKEDIN]: 'LinkedIn',
  [TAppThirdPartyIdSource.TWITTER]: 'Twitter',
  [TAppThirdPartyIdSource.INSTAGRAM]: 'Instagram',
  [TAppThirdPartyIdSource.VENMO]: 'Venmo',
  [TAppThirdPartyIdSource.FACEBOOK_MESSENGER]: 'Facebook Messenger',
  [TAppThirdPartyIdSource.WHATSAPP]: 'WhatsApp',
  [TAppThirdPartyIdSource.YELP]: 'Yelp',
  [TAppThirdPartyIdSource.SNAPCHAT]: 'Snapchat',
  [TAppThirdPartyIdSource.URL]: 'Url'
};

const openUrl = (url?: string) => {
  if (url && /^https?:\/\//i.test(url) ) {
    window.open(url, '_blank');
  } else if (url) {
    window.open('https://' + url, '_blank');
  }
};

export type WithRequired<T, K extends keyof T> = T & { [P in K]-?: T[P] }
export type TAppContactWithId = WithRequired<TAppContact, 'contactId'>;
export const hasContactId = (contact: TAppContact): contact is TAppContactWithId => contact.contactId !== undefined;


const INTERVAL_SYNC_MS = 240000; // four minutes
const SESSION_TIME_SECONDS = 86400; // 1 day in seconds
const INTERVAL_FULL_REFETCH_SECONDS = 10800; // 3 hours in seconds

export {
  openUrl,
  INTERVAL_SYNC_MS,
  SESSION_TIME_SECONDS,
  INTERVAL_FULL_REFETCH_SECONDS,
  ThirdPartyIcon,
  ThirdPartyName
};
